import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div id="support">
      <h2>{`Support`}</h2>
      <p>{`If you have questions or need help getting set-up with GIPHY SDK or API, you can take a look at our `}<a parentName="p" {...{
          "href": "https://developers.giphy.com/faq"
        }}>{`FAQ`}</a>{`.`}</p>
      <p>{`If you don’t see your question listed, feel free to submit a request through our `}<a parentName="p" {...{
          "href": "https://support.giphy.com/hc/en-us/requests/new"
        }}>{`Help Center`}</a>{` and we’ll get back to you! If you think you’ve found a bug with the `}<a href="/docs/sdk">{`SDK or API or their documentation`}</a>{`, please file an issue via `}<a parentName="p" {...{
          "href": "https://github.com/Giphy/GiphyAPI/issues"
        }}>{`GitHub Issues`}</a>{`. Thanks!`}</p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      